import { N0 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { fontCharlieDisplay } from '../devops-form-view/styled';
import { useDevopsState } from '../hook/use-devops-state';
import { messages } from '../messages';
import { DevopsImageUrlsType } from '../types';

export function SideInfoDevops() {
  const { devopsImageUrls } = useDevopsState();

  return (
    <InfoComponent>
      <DevopsLayout devopsImageUrls={devopsImageUrls}>
        <div className="devops-sidebar devops-plan">
          <SanitizedFormattedHtmlMessage {...messages.devopsSidebarTextPlan} />
        </div>
        <div className="devops-sidebar devops-code">
          <SanitizedFormattedHtmlMessage {...messages.devopsSidebarTextCode} />
        </div>
        <div className="devops-sidebar devops-deploy">
          <SanitizedFormattedHtmlMessage
            {...messages.devopsSidebarTextDeploy}
          />
        </div>
        <div className="devops-sidebar devops-operate">
          <SanitizedFormattedHtmlMessage
            {...messages.devopsSidebarTextOperate}
          />
        </div>
        <div className="devops-sidebar devops-collaborate">
          <SanitizedFormattedHtmlMessage
            {...messages.devopsSidebarTextCollaborate}
          />
        </div>
      </DevopsLayout>
    </InfoComponent>
  );
}
const InfoComponent = styled.div`
  width: 100%;
  height: 100%;
`;

const DevopsLayout = styled.div<{
  readonly devopsImageUrls?: DevopsImageUrlsType;
}>`
  position: relative;
  font-family: ${fontCharlieDisplay};
  -webkit-font-smoothing: antialiased;
  font-weight: normal;
  font-size: 18px;
  text-transform: uppercase;
  line-height: 34px;
  color: ${N0};
  background-image: url(${({ devopsImageUrls }) =>
    devopsImageUrls?.sidebarImage});
  background-repeat: no-repeat;
  background-size: contain;
  width: 534px;
  height: 595px;
  margin: 24px 0 0 -112px;

  @media (max-width: 1024px) {
    margin: 24px 0 0 -172px;
  }
  @media (max-width: 900px) {
    margin: 24px 0 0 -188px;
  }
  @media (max-width: 800px) {
    display: none;
  }

  .devops-sidebar {
    position: absolute;
    pointer-events: none;
    text-align: center;

    span {
      position: absolute;
      display: block;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: max-content;
    }

    &.devops-plan {
      top: 17px;
      right: 260px;
    }
    &.devops-code {
      top: 102px;
      right: 110px;
    }
    &.devops-deploy {
      top: 244px;
      right: 64px;
    }
    &.devops-operate {
      top: 382px;
      right: 110px;
    }
    &.devops-collaborate {
      top: 470px;
      right: 259px;
    }
  }
`;
